<template>
  <div class="direct-order-article -header">
    <div class="direct-order-article__description">
      <HeaderLabel :text="$t('sl.direct-order.headers.description')"></HeaderLabel>
    </div>
    <div class="direct-order-article__unit">
      <HeaderLabel :text="$t('sl.direct-order.headers.unit')"></HeaderLabel>
    </div>
    <div class="direct-order-article__quantity">
      <HeaderLabel :text="$t('sl.direct-order.headers.quantity')"></HeaderLabel>
    </div>
    <div class="direct-order-article__direct">
      <HeaderLabel :text="$t('sl.direct-order.headers.direct')"></HeaderLabel>
    </div>
  </div>
</template>
<script>
import HeaderLabel from '../../Design/HeaderLabel.vue'

export default {
  name: 'DirectOrderHeader',
  components: { HeaderLabel }

}
</script>
